module.exports = __webpack_public_path__ + "static/media/detail55.58c99d4b.svg";